
import type { PropType } from 'vue'
import type { PlatformRelatedPromptsPreviewItems } from '../../services'

import { SlidingPanel } from '@empathyco/x-components'

import { defineComponent } from 'vue'
import SemanticCard from '../../components/semantics/semantic-card.component.vue'

import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'RelatedPromptsPreviewItem',
  components: { SlidingPanel, SemanticCard, EpbText },
  props: {
    query: {
      type: String,
      required: true,
    },
    relatedPromptsPreview: {
      type: Array as PropType<PlatformRelatedPromptsPreviewItems[]>,
      required: true,
    },
  },
  setup() {
    const baseClass = 'related-prompts-preview-item'

    return {
      baseClass,
    }
  },
})
